<template>
	<div
		v-if="visible"
		class="pin-sheet"
		:class="{ 'is-pc': isPc }"
		@click="handleOverlayClick"
	>
		<div class="sheet-panel" @click.stop>
			<div class="sheet-handle" v-if="!isPc" aria-hidden="true"></div>
			<div class="sheet-title">{{ sheetTitle }}</div>
			<div class="ld-form pin-form">
				<div
					v-if="mode === 'change'"
					class="ld-field"
					:class="{ 'is-on': fieldOn('0', pinForm.oldWithdrawalPin) }"
				>
					<div class="ld-field-shell">
						<input
							:type="showSecret.old ? 'text' : 'password'"
							v-model="pinForm.oldWithdrawalPin"
							autocomplete="off"
							:placeholder="$t('account.oldWithdrawalPIN')"
							@focus="inputfocus('0')"
							@blur="inputblur('0')"
						/>
						<span class="ld-float-label">{{ $t('account.oldWithdrawalPIN') }}</span>
						<div
							class="ld-eye-btn"
							role="button"
							:aria-label="showSecret.old ? $t('login.hidePassword') : $t('login.showPassword')"
							@click="toggleSecret('old')"
						>
							<svg v-if="!showSecret.old" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
								<path d="M2.8 10s2.6-5 7.2-5 7.2 5 7.2 5-2.6 5-7.2 5-7.2-5-7.2-5z" stroke="currentColor" stroke-width="1.4"/>
								<circle cx="10" cy="10" r="2.2" stroke="currentColor" stroke-width="1.4"/>
							</svg>
							<svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
								<path d="M3 3l14 14M8.2 8.3A2.2 2.2 0 0010 12.2M11.8 11.7A2.2 2.2 0 0010 7.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
								<path d="M6.2 6.1C4.3 7.3 2.8 10 2.8 10s2.6 5 7.2 5c1.4 0 2.6-.4 3.7-1M13.8 13.6C15.6 12.4 17.2 10 17.2 10s-2.6-5-7.2-5c-.6 0-1.1.1-1.6.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
							</svg>
						</div>
					</div>
				</div>
				<div class="ld-field" :class="{ 'is-on': fieldOn('1', pinForm.withdrawalPin) }">
					<div class="ld-field-shell">
						<input
							:type="showSecret.pin ? 'text' : 'password'"
							v-model="pinForm.withdrawalPin"
							autocomplete="off"
							:placeholder="newPinLabel"
							@focus="inputfocus('1')"
							@blur="inputblur('1')"
						/>
						<span class="ld-float-label">{{ newPinLabel }}</span>
						<div
							class="ld-eye-btn"
							role="button"
							:aria-label="showSecret.pin ? $t('login.hidePassword') : $t('login.showPassword')"
							@click="toggleSecret('pin')"
						>
							<svg v-if="!showSecret.pin" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
								<path d="M2.8 10s2.6-5 7.2-5 7.2 5 7.2 5-2.6 5-7.2 5-7.2-5-7.2-5z" stroke="currentColor" stroke-width="1.4"/>
								<circle cx="10" cy="10" r="2.2" stroke="currentColor" stroke-width="1.4"/>
							</svg>
							<svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
								<path d="M3 3l14 14M8.2 8.3A2.2 2.2 0 0010 12.2M11.8 11.7A2.2 2.2 0 0010 7.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
								<path d="M6.2 6.1C4.3 7.3 2.8 10 2.8 10s2.6 5 7.2 5c1.4 0 2.6-.4 3.7-1M13.8 13.6C15.6 12.4 17.2 10 17.2 10s-2.6-5-7.2-5c-.6 0-1.1.1-1.6.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
							</svg>
						</div>
					</div>
				</div>
				<div class="ld-field" :class="{ 'is-on': fieldOn('2', pinForm.confirmPin) }">
					<div class="ld-field-shell">
						<input
							:type="showSecret.confirm ? 'text' : 'password'"
							v-model="pinForm.confirmPin"
							autocomplete="off"
							:placeholder="$t('account.confirmWithdrawalPIN')"
							@focus="inputfocus('2')"
							@blur="inputblur('2')"
							@keyup.enter="submitPin"
						/>
						<span class="ld-float-label">{{ $t('account.confirmWithdrawalPIN') }}</span>
						<div
							class="ld-eye-btn"
							role="button"
							:aria-label="showSecret.confirm ? $t('login.hidePassword') : $t('login.showPassword')"
							@click="toggleSecret('confirm')"
						>
							<svg v-if="!showSecret.confirm" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
								<path d="M2.8 10s2.6-5 7.2-5 7.2 5 7.2 5-2.6 5-7.2 5-7.2-5-7.2-5z" stroke="currentColor" stroke-width="1.4"/>
								<circle cx="10" cy="10" r="2.2" stroke="currentColor" stroke-width="1.4"/>
							</svg>
							<svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
								<path d="M3 3l14 14M8.2 8.3A2.2 2.2 0 0010 12.2M11.8 11.7A2.2 2.2 0 0010 7.8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
								<path d="M6.2 6.1C4.3 7.3 2.8 10 2.8 10s2.6 5 7.2 5c1.4 0 2.6-.4 3.7-1M13.8 13.6C15.6 12.4 17.2 10 17.2 10s-2.6-5-7.2-5c-.6 0-1.1.1-1.6.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
							</svg>
						</div>
					</div>
				</div>
				<div
					class="ld-btn-primary"
					:class="{ disabled: isSubmitting }"
					role="button"
					@click="submitPin"
				>{{ isSubmitting ? $t('toast.loading') : $t('loan.submit') }}</div>
				<div class="ld-btn-ghost" role="button" @click="closeDialog">{{ $t('account.cancel') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { setWithdrawalPin, changeWithdrawalPin } from '@/api/user'
import { mapState } from 'vuex'
import passField from '@/mixins/passField'

export default {
	name: 'WithdrawalPinDialog',
	mixins: [passField],
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		mode: {
			type: String,
			default: 'set',
			validator: (v) => v === 'set' || v === 'change'
		}
	},
	computed: {
		...mapState(['isPc']),
		newPinLabel() {
			return this.mode === 'change'
				? this.$t('account.newWithdrawalPIN')
				: this.$t('account.WithdrawalPIN')
		},
		sheetTitle() {
			return this.mode === 'change'
				? this.$t('account.newWithdrawalPIN')
				: this.$t('account.setWithdrawalPIN')
		}
	},
	data() {
		return {
			pinForm: {
				oldWithdrawalPin: '',
				withdrawalPin: '',
				confirmPin: ''
			},
			isSubmitting: false,
			inputSelect: {},
			showSecret: {}
		}
	},
	watch: {
		visible(val) {
			if (val) this.resetForm()
		}
	},
	methods: {
		closeDialog() {
			this.resetForm()
			this.$emit('close')
		},
		handleOverlayClick() {
			this.closeDialog()
		},
		resetForm() {
			this.pinForm = {
				oldWithdrawalPin: '',
				withdrawalPin: '',
				confirmPin: ''
			}
			this.isSubmitting = false
			this.inputSelect = {}
			this.showSecret = {}
		},
		validateForm() {
			if (this.mode === 'change') {
				if (!this.pinForm.oldWithdrawalPin) {
					this.$message.error(this.$t('20115'))
					return false
				}
				if (!this.pinForm.oldWithdrawalPin.trim()) {
					this.$message.error(this.$t('20108'))
					return false
				}
			}
			if (!this.pinForm.withdrawalPin) {
				this.$message.error(this.$t('20107'))
				return false
			}
			if (!this.pinForm.withdrawalPin.trim()) {
				this.$message.error(this.$t('20108'))
				return false
			}
			if (!this.pinForm.confirmPin) {
				this.$message.error(this.$t('account.confirmWithdrawalPIN'))
				return false
			}
			if (this.pinForm.withdrawalPin !== this.pinForm.confirmPin) {
				this.$message.error(this.$t('20109'))
				return false
			}
			if (this.mode === 'change' && this.pinForm.oldWithdrawalPin === this.pinForm.withdrawalPin) {
				this.$message.error(this.$t('20117'))
				return false
			}
			return true
		},
		async submitPin() {
			if (this.isSubmitting || !this.validateForm()) return
			this.isSubmitting = true
			try {
				let response
				if (this.mode === 'change') {
					response = await changeWithdrawalPin({
						oldWithdrawalPin: this.pinForm.oldWithdrawalPin,
						newWithdrawalPin: this.pinForm.withdrawalPin,
						confirmPin: this.pinForm.confirmPin
					})
				} else {
					response = await setWithdrawalPin({
						withdrawalPin: this.pinForm.withdrawalPin,
						confirmPin: this.pinForm.confirmPin
					})
				}
				if (response.code == 200) {
					const msgKey = response.result || (this.mode === 'change' ? '20119' : '20110')
					this.$message.success(this.$t(msgKey))
					const pin = this.pinForm.withdrawalPin
					this.resetForm()
					this.$emit('success', pin)
				} else {
					const msg = response.message || response.msg
					this.$message.error(msg ? this.$t(msg) : this.$t('20111'))
				}
			} catch (error) {
				console.error('提现PIN码提交失败:', error)
				this.$message.error(this.$t('20111'))
			} finally {
				this.isSubmitting = false
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.pin-sheet {
	position: fixed;
	inset: 0;
	z-index: 120;
	background: var(--ld-overlay, rgba(17, 17, 17, 0.36));
	display: flex;
	align-items: flex-end;
	justify-content: center;
	box-sizing: border-box;
}

.pin-sheet.is-pc {
	align-items: center;
	padding: 24px;
}

.sheet-panel {
	width: 100%;
	max-width: 520px;
	background: var(--ld-bg-card, #fff);
	color: var(--ld-text, #111);
	border-radius: 20px 20px 0 0;
	padding: 10px 16px calc(16px + var(--ld-safe-bottom));
	box-sizing: border-box;
}

.pin-sheet.is-pc .sheet-panel {
	width: 400px;
	max-width: 92vw;
	border-radius: 16px;
	padding: 20px 16px 16px;
	box-shadow: var(--ld-shadow);
}

.sheet-handle {
	width: 36px;
	height: 4px;
	border-radius: 999px;
	background: var(--ld-handle, #d8d8d8);
	margin: 6px auto 12px;
}

.sheet-title {
	font-size: 16px;
	font-weight: 600;
	text-align: center;
	padding: 4px 12px 8px;
}

.pin-form {
	margin-top: 12px;
}

.ld-btn-ghost {
	margin-top: 10px;
	width: 100%;
}

.ld-eye-btn:active {
	border-radius: 8px !important;
}
</style>
